import styles from './brand-selector.module.scss';
import { Button, Form, Select, Space } from "antd";
import brandsStorage from "../storages/brands";
import { observer } from 'mobx-react-lite';
import { filterOption } from "../helpers/table-helpers";
import { PlusOutlined } from "@ant-design/icons";
import { AddBrandDialog } from "../dialogs/add-brand-dialog";
import { IBrand } from "@drone-parts.garphild.pro/interfaces";
import layoutStorage from "../storages/layout-storage";

/* eslint-disable-next-line */
export interface BrandSelectorProps {
  brand: IBrand['_id'];
  selectBrand: (brandId: IBrand['_id']) => void;

}

export function BrandSelector(
  {
    brand,
    selectBrand,
  }: BrandSelectorProps) {

  const toggleAddBrandDialog = () => {
    layoutStorage.toggleAddBrandDialog();
  }

  return (
    <>
      <Form.Item
        label="Brand"
      >
        <Space.Compact className={styles['selector']}>
          <Select
            className={styles['select']}
            showSearch
            value={brand || ""}
            onChange={(value: IBrand['_id']) => selectBrand(value)}
            filterOption={filterOption}
            options={[
              { value: "", label: 'Select brand' },
              ...brandsStorage.brandsAsLabels,
            ]}
          >
          </Select>
          <Button type="primary" onClick={() => toggleAddBrandDialog()}>
            <PlusOutlined />
          </Button>
        </Space.Compact>
      </Form.Item>
      <AddBrandDialog opened={layoutStorage.isAddBrandDialogOpened} onToggle={toggleAddBrandDialog} />
    </>
  );
}

export default observer(BrandSelector);
